import { render } from "./menuPower.vue?vue&type=template&id=2349419e&scoped=true"
import script from "./menuPower.vue?vue&type=script&lang=js"
export * from "./menuPower.vue?vue&type=script&lang=js"

import "./menuPower.vue?vue&type=style&index=0&id=2349419e&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2349419e"]])

export default __exports__